//数据统计
import http from '../jslibs/axios/http';

// 用户数据
export const getBillUserStat = data => http.get('/cms/Bill/user_stat', data);
// 用户排行
export const getBillUserRank = data => http.get('/cms/Bill/user_rank', data);
// 课程数据
export const getBillCourseStat = data => http.get('/cms/Bill/course_stat', data);
// 用户会员类型分布/付费会员数量分布
export const getBillUserMember = data => http.get('/cms/Bill/user_member', data);
// 培训数据
export const getBillTrainStat = data => http.get('/cms/Bill/train_stat', data);
// 培训收入明细
export const getBillTrainOrder = data => http.get('/cms/Bill/train_order', data);
// 热卖课程
export const getBillCourseRank = data => http.get('/cms/Bill/course_rank', data);
// 统计
export const getBillStat = data => http.get('/cms/Bill/stat', data);
//交易流水明细
export const getBill = data => http.get('/cms/Bill', data);
//营收统计/收入分析
export const getAnalyze = data => http.get('/cms/Bill/analyze', data);
//营销排行
export const getRank = data => http.get('/cms/Bill/rank', data);
export const getBillCourseRankQs = data => http.get('/cms/Bill/order_analyze', data);

